import script from "./PanelShell.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelShell.vue?vue&type=script&setup=true&lang=js"

import "./PanelShell.vue?vue&type=style&index=0&id=23b80fcb&scoped=true&lang=css"
import "./PanelShell.vue?vue&type=style&index=1&id=23b80fcb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b80fcb"]])

export default __exports__